// Verkaufen page (sell-hero, sell-journey, sell-pick, faq): scroll-driven motion without GSAP, model suggestions
// and card photos from the live Ankauf catalog (via window.janado.tradeIn from assets/trade-in.js), FAQ tabs.

const reduced = document.documentElement.classList.contains('reduced')
const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v))
const seg = (t, a, b) => clamp((t - a) / (b - a))
const easeOut = (t) => 1 - (1 - t) ** 3
const backOut = (t) => 1 + 2.6 * (t - 1) ** 3 + 1.6 * (t - 1) ** 2

const onScroll = []
let ticking = false
addEventListener('scroll', () => ticking || ((ticking = true), requestAnimationFrame(() => ((ticking = false), onScroll.forEach((f) => f())))), { passive: true })

// [data-inview] → .in once (sections that pop in when scrolled to)
const io = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && (e.target.classList.add('in'), io.unobserve(e.target))), { rootMargin: '0px 0px -15% 0px' })
document.querySelectorAll('[data-inview]').forEach((el) => io.observe(el))

// ---------- Hero: blob sinks and shrinks, the phone tumbles down as you leave ----------
const hero = document.querySelector('[data-sell-hero]')
if (hero && !reduced) {
  const blob = hero.querySelector('.sell-hero__blob')
  const img = hero.querySelector('.sell-hero__img')
  const update = () => {
    const p = clamp(scrollY / hero.offsetHeight)
    blob.style.transform = `translateY(${90 * p}%)`
    blob.dataset.blobScale = (1 - 0.6 * p).toFixed(3)
    if (img) img.style.transform = `translateY(${80 * p}%) rotate(${-28 * p}deg)`
  }
  onScroll.push(update)
  update()
}

// ---------- Journey: your old phone tumbles out, the blob squashes, turns yellow, a new phone drops in ----------
const journey = document.querySelector('[data-journey]')
if (journey && !reduced) {
  const blob = journey.querySelector('.journey__blob')
  const old = journey.querySelector('.journey__old')
  const neu = journey.querySelector('.journey__new')
  let yellow = null
  const update = () => {
    const r = journey.getBoundingClientRect()
    const t = clamp(-r.top / (r.height - innerHeight)) * 3.4 // the prototype's timeline in beats
    const squash = 1 - 0.2 * seg(t, 1, 1.5) - 0.3 * seg(t, 1.5, 2) + 0.4 * backOut(seg(t, 2.3, 2.9)) - 0.1 * seg(t, 2.9, 3.3)
    blob.dataset.blobScale = squash.toFixed(3)
    if (old) {
      const a = easeOut(seg(t, 1, 1.8))
      const b = seg(t, 1.7, 2.2)
      Object.assign(old.style, { transform: `translateY(${40 * a + 120 * b}%) rotate(${90 * a}deg) scale(${1 - 0.3 * a})`, opacity: 1 - b })
    }
    if (neu) {
      const u = seg(t, 2.4, 3.2)
      const b = backOut(u)
      Object.assign(neu.style, { transform: `translateY(${-60 + 60 * b}%) rotate(${-20 + 20 * b}deg)`, opacity: u })
    }
    const y = t > 2.45
    if (y !== yellow) blob.dataset.blobColor = y ? 'yellow' : 'lavender'
    yellow = y
  }
  onScroll.push(update)
  update()
}

// ---------- Live catalog: suggestions for the quick search, photos for the model cards ----------
addEventListener('load', async () => {
  const ti = window.janado?.tradeIn
  if (!ti) return
  const list = document.querySelector('[data-sell-models]')
  const cards = [...document.querySelectorAll('[data-sell-card]')]
  if (!list && !cards.length) return
  try {
    const models = await ti.catalog()
    if (list) list.innerHTML = models.map((m) => `<option value="${m.name.replace(/"/g, '&quot;')}">`).join('')
    for (const li of cards) {
      const m = models.find((x) => x.name.toLowerCase() === li.dataset.sellCard.toLowerCase())
      if (!m) {
        li.hidden = true // a model the catalog doesn't buy
        continue
      }
      const img = li.querySelector('img')
      img.src = ti.image(m.variants[0])
      img.hidden = false
    }
  } catch {
    // catalog unreachable: the cards still open the tool, which shows its own error
  }
}, { once: true })
